import { themeColors } from 'colors';

/**
 * Shared layout for Users table cells with an inline control (role dropdown, name edit).
 * Kept in sync with {@link UsersTableRoleSelectionCell}.
 */
export const usersTableInteractiveCellStackSx = {
    minWidth: 0,
    maxWidth: '80%',
    width: '100%',
    typography: 'body1',
    fontFamily: 'inherit',
};

export const usersTableInteractiveCellValueBoxSx = {
    flex: '0 1 auto',
    minWidth: 0,
    overflow: 'hidden',
    maxWidth: '100%',
};

export const usersTableInteractiveCellTriggerIconButtonSx = {
    flexShrink: 0,
    p: 0.25,
};

const usersTableOutlinedInputActiveSx = {
    typography: 'body1',
    fontFamily: 'inherit',
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: themeColors.action.active,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: themeColors.action.active,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: themeColors.action.active,
        borderWidth: 2,
    },
};

/**
 * Inline name edit field — same outline treatment as the role popover SearchField.
 */
export const usersTableInlineEditableTextFieldSx = {
    minWidth: 0,
    maxWidth: '100%',
    marginRight: 0,
    '& .MuiInputBase-input': {
        typography: 'body1',
        fontFamily: 'inherit',
    },
    '& .MuiOutlinedInput-root': usersTableOutlinedInputActiveSx,
};

/**
 * Role popover search — extends inline field styles with placeholder tokens (SearchField).
 */
export const usersTableRolePopoverSearchFieldSx = {
    minWidth: 0,
    maxWidth: '100%',
    marginRight: 0,
    '& .MuiInputBase-input': {
        typography: 'body1',
        fontFamily: 'inherit',
        '&::placeholder': {
            typography: 'body2',
            fontFamily: 'inherit',
            opacity: 1,
            color: 'text.secondary',
        },
    },
    '& .MuiOutlinedInput-root': usersTableOutlinedInputActiveSx,
};
